// @flow

import { trackLink, trackImpression } from 'lib/analytics/fpti'

export const CASH_ADV_FEES_PAGE_GROUP = 'main:p2p:unified:cashadvance'

const pageImpressionMap = {
  aboutFeesOverPanel: {
    pageGroup: `${CASH_ADV_FEES_PAGE_GROUP}`,
    pageName: `${CASH_ADV_FEES_PAGE_GROUP}:moreinfo`,
    extra: {
      pglk: 'main:p2p:unified:choice:fioption|about_cc_fee',
    },
  },
  warningFeesOverpanel: {
    pageGroup: `${CASH_ADV_FEES_PAGE_GROUP}disclaimer`,
    pageName: `${CASH_ADV_FEES_PAGE_GROUP}disclaimer::overlay`,
    extra: {
      pglk: 'main:p2p:unified:choice:fioption|select',
    },
  },
  inlineWarning: {
    something: 'something',
  },
}

const pageActionMap = {
  updatePaymentOption: {
    link: 'update',
    pageGroup: `${CASH_ADV_FEES_PAGE_GROUP}disclaimer`,
    pageName: `${CASH_ADV_FEES_PAGE_GROUP}disclaimer::overlay`,
    extra: {},
  },
  payWithCard: {
    link: 'continue',
    pageGroup: `${CASH_ADV_FEES_PAGE_GROUP}disclaimer`,
    pageName: `${CASH_ADV_FEES_PAGE_GROUP}disclaimer::overlay`,
    extra: {},
  },
  cancelCashAdvanceFeeWarning: {
    link: 'cancel',
    pageGroup: `${CASH_ADV_FEES_PAGE_GROUP}disclaimer`,
    pageName: `${CASH_ADV_FEES_PAGE_GROUP}disclaimer::overlay`,
    extra: {},
  },
  okAbout: {
    link: 'ok',
    pageGroup: `${CASH_ADV_FEES_PAGE_GROUP}`,
    pageName: `${CASH_ADV_FEES_PAGE_GROUP}:moreinfo`,
    extra: {},
  },
  moreInfo: {
    link: 'about_cc_fee',
    pageGroup: 'main:p2p:unified:choice:fioption',
    pageName: 'main:p2p:unified:choice:fioption::node',
    extra: {},
  },
  inlineMoreInfo: {
    link: 'about_cc_fee_inline',
    pageGroup: 'main:p2p:unified:choice:fioption',
    pageName: 'main:p2p:unified:choice:fioption::node',
    extra: {},
  },
  previewInlineMoreInfo: {
    link: 'about_cc_fee',
    pageGroup: 'main:p2p:unified:send::review',
    pageName: 'main:p2p:unified:send::review:node::',
    extra: {},
  },
  closeMoreInfo: {
    link: 'close',
    pageGroup: `${CASH_ADV_FEES_PAGE_GROUP}`,
    pageName: `${CASH_ADV_FEES_PAGE_GROUP}:moreinfo`,
    extra: {},
  },
}
/**
 * Track impression via FPTI analytics
 * @param {Object} data - FPTI data to track with the impression
 */
export function trackCashAdvanceFeesImpression(pageImpression: string) {
  const { pageName, pageGroup, extra } = pageImpressionMap[pageImpression]
  trackImpression(pageGroup, pageName, extra)
}

/**
 * Track users clicks via FPTI analytics
 */
export function trackCashAdvanceFeesClick(pageAction: string) {
  const { pageName, pageGroup, link, extra } = pageActionMap[pageAction]
  trackLink(link, pageGroup, pageName, 'link', extra)
}
